import React, { useState, useEffect, useRef, useCallback } from 'react';
import './ComponentCss/CompanyCardListInName.css'; // 스타일을 위한 CSS 파일
import { OrderedItemFieldKeys, OrderedItemResFieldKeys } from '../DataBind/Payment';
import { toCommaedNumber } from "../DataBind/common";
import { TimeData } from "../DataBind/Time";
import { useRerender } from "../hooks";
import axios from "axios";
import config from "../ip.json";

/**
 * @param {CompanyData} data
 * @param {{editDisabled: boolean, hideCompanyName: boolean, hideRoomNumber: boolean} | null} option
*/
const CompanyCardListInName = ({data, option}) => {
    const { editDisabled, hideCompanyName, hideRoomNumber } = option ?? {};
    // const [modalVisible, setModalVisible] = useState(false); // 모달 상태
    // const modalPosition = useRef({ x: 0, y: 0 }).current; // 모달 위치 상태
    // const [activeButton, setActiveButton] = useState(null); // 클릭한 버튼 저장
    // ^ 이건 ref 를 써요. 렌더링 불필요하게 발생하는데 그럴 필요가 전혀 없음
    // const activeIdRef = useRef({ value: null }).current;

    const modal = useRef(null);
    const [selectedDate, setSelectedDate] = useState(''); // 선택된 날짜 상태
    // const [errorMessage, setErrorMessage] = useState('');
    const rerender = useRerender();

    // 모달 상태 (위치, 오류, 표시여부, 선택id)
    const modalStatus = useRef({
        x: 0,
        y: 0,
        visibility: false,
        error: '',
        activeId: null,
    }).current;

    // 모달 열기
    const openModal = useCallback(e => {
        if (editDisabled) return;
        e.stopPropagation();

        // 이렇게 돼 있으면 곤란해요
        // state 를 여러번 업데이트 하는 effect 는 렌더 과정을
        // 복잡하게 만들어서 디버깅이 어렵습니다.
        // useRef 등으로 update 하더라도 render 를 트리거 하지 않는
        // 데이터셋을 만들고 전부 업데이트 후 명시적으로 render
        // 트리깅을 하거나 (state 에 [] 를 넣는 식 비슷하게)
        // 하나의 state 로 합쳐주세요.

        // 클릭한 버튼의 위치 가져와 모달 위치 업데이트
        const { right, top } = e.target.getBoundingClientRect();
        modalStatus.x = Math.floor(right + 10);
        modalStatus.y = Math.floor(top);

        // 모달 가시성과 id 업데이트
        modalStatus.activeId = +e.target.dataset.id;
        modalStatus.visibility = true;

        rerender(); // 렌더 트리거 (한번만!)
    }, []);

    // 모달 닫기
    const closeModal = useCallback(() => {
        modalStatus.visibility = false;
        rerender(); // 명시적 렌더 트리거
    }, []);

    // 날짜 변경 처리
    const handleDateChange = useCallback((e) => { // 이정도는 그냥 익명함수 처리해도
        // 보통 event callback 을 const 같은 곳에 넣는거는 useCallback 을 사용하는데
        // 그 이유가 일급객체인 익명함수(closure != function)가 render 마다 달라지기
        // 때문에 (항상 equality 가 false) addeventlistener 처리가 반복 발생함을 막기
        // 위함인데. 이것 처럼 그냥 const 에다 넣으면 의미가 사실 없음. 의미가
        // 아니면 렌더링이 그렇게 자주 안 일어나서 코스트가 무시 가능하면
        // 있으려면 위 처럼, 라인이라도 아끼게 hardcode
        // 개인적으론 layout change 나는 cost 아닌 이상 hardcode 하는 편입니다

        setSelectedDate(e.target.value); // 날짜 상태 업데이트
    }, []);

    // FROM: /code/Projects/excel-frontend/src/Components/CompanyCardListinRoomNumber.js
    const update = async () => {
        const jwtToken = sessionStorage.getItem("Authorization");
        try {
            const response = await axios.post(config.url + "/v2/payment/company/pay_update",
                {
                    id: Number(data.id),
                    resRent: data.resRent?.toText() ?? null,
                    resSurtax: data.resSurtax?.toText() ?? null,
                    resElec: data.resElectric?.toText() ?? null,
                    resGas: data.resGas?.toText() ?? null,
                },
                {
                    headers: {
                        Authorization: jwtToken,

                        "Content-Type": "application/json",
                    },
                    withCredentials: true, // 쿠키 필요 시 설정
                });

            console.log(response.data); // 콘솔로 데이터 확인
        } catch (error) {
            console.error("Error fetching data:", error);
            alert("데이터를 가져오는 중 문제가 발생했습니다.");
        }
    }

    // 날짜 선택 후 버튼 텍스트 업데이트
    const makeProcessedPayment = useCallback(() => {
        // if (activeButton) {
        // no indent!!!!!!!!!!!!! please use if(!...) () return;
        // 펄 같은 구문바보언어도 아니고 js 인데

        // 예외처리
        if (!selectedDate) {
            // 날짜를 선택하지 않았을 때 경고 메시지 표시
            modalStatus.error = '날짜를 설정해주세요.';
            return rerender();
        }
        if (modalStatus.activeId === null) return closeModal();

        // 여긴 data 객체를 업데이트 해버리면 해결
        data[
            OrderedItemResFieldKeys[modalStatus.activeId]
        ] = TimeData.fromText(selectedDate);

        // 이 부분을 modalStatus 같은거로 묶어서 { open: boolean, err: string } 같은걸
        // 만들어주고 이걸 업데이트 트리거로 쓰던가 해도 좋을듯
        // if (errorMessage != '') setErrorMessage(''); // 에러 메시지 초기화
        // closeModal(); // 모달 닫기

        // 그래서 그렇게 했어요
        modalStatus.error = '';
        modalStatus.activeId = null;
        closeModal(); // 여기서 render 딱 한번
        update();
    }, [ selectedDate, data ]);

    // 미납처리 버튼 클릭 시 처리
    const makeMissedPayment = useCallback(() => {
        if (modalStatus.activeId === null) return closeModal();

        data[OrderedItemResFieldKeys[modalStatus.activeId]] = null;

        modalStatus.error = '';
        modalStatus.activeId = null;
        closeModal();
        update();
    }, [ data ]);

    // 모달 외부 클릭 시 모달 닫기 (이벤트 리스너 추가)
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!modal.current) return;
            if (modalStatus.activeId === null) return;
            if (!modalStatus.visibility) return
            //                 v Baseline Widely available
            if (!modal.current.matches(':hover')) closeModal(); // 호버중이 아니면 close
        };

        // 이벤트 리스너 등록
        document.addEventListener('mousedown', handleClickOutside);

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={'list-box'}>
            {hideCompanyName ? null :
                <div className={'list-element'}>
                    <div className={'top-company-name'}>{data.company}</div>
                    <div className={'bottom'}>
                    </div>
                </div>
            }
            <div className={'list-element'}>
                <div className={'top'}>{data.createTime.year}년 {data.createTime.month}월</div>
                {hideRoomNumber ? null :
                    <div className={'bottom'} style={{fontWeight: "bold", fontSize: 16, color: "#212121"}}>
                        {data.room}호
                    </div>
                }
            </div>
            { OrderedItemFieldKeys.map((key, id) =>
                <div className={'list-element'} key={key}>
                    <div className={'top'}>{toCommaedNumber(data[key])} 원</div>
                    <div className={'bottom'}>
                        <div
                            className={`isPayed_${id + 1}`}
                            onClick={openModal}
                            data-id={id}
                            style={{
                                backgroundColor: data[OrderedItemResFieldKeys[id]] ? '' : '#FEF0EF' // 미납처리 상태에 따라 색상 변경
                            }}
                        >
                            {data[OrderedItemResFieldKeys[id]]?.toText() ?? '미납처리'} {/* 버튼 텍스트 수정 */}
                        </div>
                    </div>
                </div>
            )}
            <div className={'list-element'}>
                <div className={'last-top'}>{toCommaedNumber(data.total)} 원</div>
                <div className={'bottom'}></div>
            </div>

            {/* 모달 */}
            {modalStatus.visibility && (
                <div ref={modal} className="modal" style={{left: modalStatus.x, top: modalStatus.y - 50}}>
                    <div className="modal-content">
                        <div>
                            <label htmlFor="date-picker">날짜 선택:</label>
                            <input
                                id="date-picker"
                                type="date"
                                value={selectedDate}
                                onChange={handleDateChange}
                            />
                        </div>

                        {/* 날짜가 설정되지 않았을 때 에러 메시지 */}
                        {modalStatus.error && <div style={{color: 'red', marginTop: '10px'}}>{modalStatus.error}</div>}

                        <div>
                            <p>선택된 날짜: {selectedDate}</p>
                        </div>

                        <button onClick={makeProcessedPayment} className={'firstButton'}>납입완료</button>
                        <button onClick={makeMissedPayment} className={'middleButton'}>미납처리</button>
                        <button onClick={closeModal}>닫기</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CompanyCardListInName;
